import type { Step } from "react-joyride";

export const payrollFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ແກ້ໄຂລາຍການເງິນເດືອນ. ທ່ານສາມາດບັນທຶກຮ່າງ, ຢືນຢັນ ຫຼື ຊຳລະ ແລະ ເບິ່ງ/ພິມໃບ slip.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="payroll-form-back"]',
    content: "ກັບໄປລາຍການເງິນເດືອນ ຫຼື ເບິ່ງໃບ slip. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-form-form"]',
    content:
      "ແກ້ໄຂຂໍ້ມູນເງິນເດືອນ: ເງິນເດືອນພື້ນຖານ, OT, ເງິນອຸດໜານ, ລາຍການຫັກ. ບັນທຶກຮ່າງ ຫຼື ຢືນຢັນ / ຊຳລະຕາມສະຖານະ.",
    placement: "top",
  },
];
